var cifKw = ["301 151", "<g fill='none'><path fill='#007A3D' d='M.5.5h300v50H.5z'/><path fill='#FFF' d='M.5 50.5h300v50H.5z'/><path fill='#CE1126' d='M.5 100.5h300v50H.5z'/><path fill='#000' d='M.5.5l75 50v50l-75 50z'/></g>"];

export { cifKw };

